<template>
  <div class="headline" id="headline">
    <div class="top-line">
      <div class="line-left border-right">
          <p>易货</p>
          <p class="line">头条</p>
      </div>
      <div class="message">
        <swiper :options="swiperOption" v-if="list.length > 0">
          <swiper-slide v-for="item in list" :key="item.id">
            <router-link tag="div" :to="'/platform/' + item.id">
              {{item.desc}}
            </router-link>
          </swiper-slide>
        </swiper>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeHeadLine',
  props: {
    list: Array
  },
  data () {
    return {
      swiperOption: {
        direction: 'vertical', // 竖屏滚动
        loop: true, // 循环滚动
        autoplay: true,
        speed: 400
      }
    }
  }
}
</script>

<style scoped>
.headline{ height: 53px; overflow: hidden;}
.top-line{ display: flex; justify-content: flex-start; padding: 9px 0;}
.line-left{ padding: 0 9px;}
.top-line p{ font-size: 14px; letter-spacing: 1px; color: #fd5a0d; line-height: 16px; font-weight: bold;}
.top-line .line{ color: rgb(51, 51, 51);}
.message a{ text-decoration: none; color: #7f7f7f; height: 43px;}
.top-line .message{ padding: 8px 7px; background-color: #fff; width: 80%;}
.top-line .message p{ color: #7f7f7f; font-weight: normal; font-size: 13px; letter-spacing: 0;}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/Headline.vue